import React, { useState, useEffect  } from "react";
import { Autocomplete, Button, Container, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormHelperText, Grid, TextField, FormControlLabel, Box  } from "@mui/material";
import { PictureAsPdfRounded, AttachFile } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { FcInfo } from "react-icons/fc";
import { getEkedEquipments, getEkedEquipmentFilePreviews } from "../../store/actions/EkedEquipmentActions";


export default function SecurityPopup(props) {
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();
    let [rows, setRows] = useState([]);

    useEffect(() => {
        dispatch(getEkedEquipments());
    }, []);

    const { EkedEquipment } = useSelector((EkedEquipment) => EkedEquipment);

    useEffect(() => {
        if (EkedEquipment?.ekedEquipmentList?.resultObject) {
            if (EkedEquipment.ekedEquipmentList.resultObject.length > 0) {
                const resultObject = EkedEquipment.ekedEquipmentList.resultObject
                setRows(Object.values(resultObject));
                props.setSelectedEkedEquipmentNames(props.selectedEkedEquipmentIds.map((item) => resultObject.find((equipment) => equipment.id === item).name));
                props.setTempEkedEquipmentNames(props.selectedEkedEquipmentIds.map((item) => resultObject.find((equipment) => equipment.id === item).name));

                if(filePreview.length === 0){
                    dispatch(getEkedEquipmentFilePreviews(resultObject.map(element => element.id)));
                }
            }
            else {
                setRows([]);
            }
            if (EkedEquipment?.ekedEquipmentFilePreviews && EkedEquipment?.ekedEquipmentFilePreviews?.length !== 0) {
                setFilePreview(EkedEquipment?.ekedEquipmentFilePreviews)
            }
        }
    }, [EkedEquipment.ekedEquipmentList]);

    const onChangeCheckbox = () => {
        props.setIsChecked(!props.isChecked);
        if(props.isChecked) {
            setRows([]);
            props.setTempEkedEquipmentIds([]);
            props.setTempEkedEquipmentNames([]);
        }
        else {
            dispatch(getEkedEquipments());
        }
    };

    const [openDialog, setOpenDialog] = useState(false);
    const showEquipmentDetails = () => {
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };


    const [filePreview, setFilePreview] = useState([]);

    const renderFilePreview = (rowId) => {
        if(filePreview.length > 0){
            const file = filePreview.find(element => element.name.split(".")[0] === rowId.toString())
            if(file){
                const fileExtension = file.name.split(".").pop();
                if (["jpg", "jpeg", "png", "gif"].includes(fileExtension)) {
                    return (
                        <img
                            id={`docp_Img_preview_${file.name}`}
                            width={70}
                            height={70}
                            alt={file.name}
                            src={window.URL.createObjectURL(file.blob)}
                            style={{ cursor: "pointer" }}
                        />
                    );
                } else if (["pdf"].includes(fileExtension)) {
                    return <PictureAsPdfRounded id={`docp_Pdf_preview_${file.name}`} fontSize="large" />;
                } else {
                    return <AttachFile id={`docp_AttachFile_preview_${file.name}`} fontSize="large" />;
                }
            }
          

        }
    };

    return (
        <Container id="sc_Container">
            <Dialog open={props.securityDialogOpen} id="sc_dialog_6" fullWidth="xs">
                <DialogTitle id="sc_dialogT_7" style={{ position: "relative", paddingBottom:"5px" }}>
                    <Grid container direction="row" style={{ justifyContent: "space-between", alignItems: "center" }}>
                        {t("WarningNotice")}
                        <IconButton onClick={props.HandleSecurityDialogClose}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </DialogTitle>
                <DialogContent id="sc_dialogContent_6" sx={{fontSize:'0.9em', marginTop: "0px", paddingBottom:"5px"}}>
                    <h3  sx={{marginTop: "0px"}}>{t("WarningMessage")}</h3>
                </DialogContent>
                <Grid container direction="row" style={{ alignItems: "center", justifyContent: "flex-start", padding:"24px" , paddingTop:"0px"}} fullWidth="xs">
                    <FormControlLabel sx={{}} control={<Checkbox disabled={props.disabledEked}  id={`sc_Checkbox`} color="secondary" checked={props.isChecked} onChange={onChangeCheckbox} />} label={t("EkedWasUsed")} labelPlacement="end"/>
                    <FormControl id="sc_fromControl_14" style={{ width: "100%" }}>
                        <Autocomplete
                            disabled={!props.isChecked || props.disabledEked}
                            multiple
                            id="sc_autoComplete_21"
                            options={rows}
                            limitTags={3}
                            value={rows.filter((item) => props.tempEkedEquipmentIds?.includes(item.id))}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => 
                            <TextField id="sc_textFiled_25" {...params} margin="normal" label={t("EkedEquipments")} variant="outlined" />
                            }
                            onChange={(event, newValue) => {
                                props.HandleEkedEquipment(newValue);
                            }}
                            renderOption={(props, option) => (
                                <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                                 {renderFilePreview(option.id)} {option.name}
                                </Box>
                              )}
                            size={props.size ?? "normal"}
                        />
                    </FormControl>
                    <Grid container direction="row" fullWidth="xs">
                        <FormHelperText className="noteAreaStyle" onClick={() => showEquipmentDetails()}>
                            <FcInfo fontSize="2rem" style={{ marginTop: 10, marginRight: 10 }}/>
                        </FormHelperText>
                        <h4 onClick={() => showEquipmentDetails()}>{t("EkedSelected")}</h4>
                    </Grid>
                </Grid>
                <DialogActions id="sc_dialogAct_6">
                    <Button disabled={props.disabledEked} id="sc_button_10" onClick={props.HandleSecurityDialogConfirm}>
                        <h4>{t("Confirm")}</h4>
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openDialog} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="md_DialogTitle">{t("Information")}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="md_DialogDesc" style={{overflow: "hidden", wordWrap: "break-word"}}>
                        {props.tempEkedEquipmentNames.map((ekedEquipments) => <li> {ekedEquipments}</li>)}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        {t("Confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}
